import { Component } from "@angular/core";
import { TranslatePipe } from "../../shared/i18n/translate.pipe";

@Component({
  selector: "app-success-page",
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: "./success-page.component.html",
  styleUrl: "./success-page.component.scss",
})
export class SuccessPageComponent {
}
